// extracted by mini-css-extract-plugin
module.exports = {"flexColumn":"Layouts_flexColumn__ajbND","p-b-1":"Spaces_p-b-1__67lqI","container":"NewSurveyOptions_container__1mM46 Layouts_flexColumn__ajbND Spaces_p-b-1__67lqI"};